import { render, staticRenderFns } from "./MyCheckCreditReformResult.vue?vue&type=template&id=284a3e57&"
import script from "./MyCheckCreditReformResult.vue?vue&type=script&lang=js&"
export * from "./MyCheckCreditReformResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AeqDocumentList: require('/home/vsts/work/1/s/components/AeqDocumentList.vue').default})
